import {combineLatestWith, Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { TreeNode } from '@ali-hm/angular-tree-component';
import * as RA from 'ramda-adjunct';
import {ItemSummary} from '@emm/core/models/item-summary.model';

export interface ItemNode {
    data: any;
    hasChildren: boolean;
    id: string | number;
    name: string;
    isStruck?: boolean;
    commonItem?: boolean;
}

export function mapItemToNode(item: ItemSummary, featureScope:  string): ItemNode {
    return {
        data: item,
        hasChildren: featureScope === 'Global' && item?.commonItem ? false : item.childCount > 0 || item.hasChildren,
        id: item.tagPath,
        name: item.name,
        isStruck: false,
    };
}

export function getParentPath(path: string): string {
    if (RA.isNilOrEmpty(path)) {
        return '';
    }

    const itemUrls = getItemUrls(path);
  /*
      item path of $.items[?(@.tag == 'MOBILE_BREAKFAST')].items[?(@.tag == 'CFA_BISCUIT_MEAL')].items[?(@.tag == 'BISCUIT_CHICKEN')]
      passed to getItemUrls returns:

      0: "$.items[?(@.tag == 'MOBILE_BREAKFAST')]"
      1: "$.items[?(@.tag == 'MOBILE_BREAKFAST')].items[?(@.tag == 'CFA_BISCUIT_MEAL')]"
      2: "$.items[?(@.tag == 'MOBILE_BREAKFAST')].items[?(@.tag == 'CFA_BISCUIT_MEAL')].items[?(@.tag == 'BISCUIT_CHICKEN')]"
  */
    const parentIndex = itemUrls.length - 2;

    return parentIndex >= 0 ? itemUrls[parentIndex] : '';
}

export function getItemUrls(jsonPath: string): string[] {
    if (RA.isNilOrEmpty(jsonPath)) {
        return [];
    }

    const items = jsonPath.substring(1, jsonPath.length).split('.items').filter(Boolean);

    return items.reduce((acc, cur, idx) => {
        return [...acc, idx > 0 ? `${acc[idx - 1]}.items${cur}` : `$.items${cur}`];
    }, []);
}

export function mapItemsToNode(items: ItemSummary[], featureScope: string): ItemNode[] {
    return JSON.parse(JSON.stringify(
        items.map(item => TreeUtil.mapItemToNode(item, featureScope))
    ));
}

export function filter(searchText: string, searchType: string, node: TreeNode) {
    if (searchText) {
        searchText = searchText.toLowerCase();
    }

    if (searchType === 'tag') {
        const stripped = node?.data?.tag?.replace(/[_-]/g, ''); // remove underscores
        return (
            node?.data?.tag?.toLowerCase()?.includes(searchText) ||
            stripped?.toLowerCase()?.includes(searchText)
        );
    } else if (searchType === 'name') {
        return node?.data?.name?.toLowerCase()?.includes(searchText);
    }
}

export function isRoot(node: TreeNode) {
    // same as library's isRoot but doesn't error out when parent is null
    return node?.parent?.data?.virtual;
}

export const TreeUtil = {
    filter,
    getParentPath,
    isRoot,
    mapItemToNode,
    mapItemsToNode
};
